import { Box, Container, Heading, SimpleGrid, Text, Stack, Flex } from '@chakra-ui/react';
import { Search, Info, Eye } from 'lucide-react';

interface FeatureProps {
  title: string;
  text: string;
  icon: React.ReactElement;
}

const Feature = ({ title, text, icon }: FeatureProps) => {
  return (
    <Stack align="center" textAlign="center">
      <Flex
        w={16}
        h={16}
        align="center"
        justify="center"
        color="gray.800"
        rounded="full"
        bg="brand.primary"
        mb={4}
      >
        {icon}
      </Flex>
      <Text fontWeight={600} fontSize="lg" mb={2}>{title}</Text>
      <Text color="gray.600">{text}</Text>
    </Stack>
  );
};

const FeaturesSection = () => {
  return (
    <Box id="features" py={20} bg="white">
      <Container maxW="1200px">
        <Box textAlign="center" mb={16}>
          <Heading
            as="h2"
            textStyle="heading"
            position="relative"
            mb={5}
            _after={{
              content: '""',
              width: '70px',
              height: '4px',
              backgroundColor: 'brand.secondary',
              position: 'absolute',
              bottom: '-10px',
              left: '50%',
              transform: 'translateX(-50%)',
            }}
          >
            What DIYBuddy Can Do For You
          </Heading>
          <Text fontSize="lg" color="gray.600" maxW="800px" mx="auto" mt={8}>
            Your all-in-one solution for home repairs and DIY projects, putting expert knowledge at your fingertips.
          </Text>
        </Box>

        <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} gap={10}>
          <Feature
            icon={<Search size={24} />}
            title="Problem Diagnosis"
            text="Identify home issues with our guided troubleshooting system that helps pinpoint the exact problem."
          />
          <Feature
            icon={<Info size={24} />}
            title="Professional Recommendations"
            text="Can't DIY? We'll suggest the right type of contractor for your specific issue."
          />
          <Feature
            icon={<Eye size={24} />}
            title="Part Identification"
            text="Quickly identify replacement parts like lightbulbs, sprinkler heads, or appliance components with visual recognition and guided questions."
          />
        </SimpleGrid>
      </Container>
    </Box>
  );
};

export default FeaturesSection;
